import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { EICFConsentsApi } from '../../../apis/EICFApi/EICFConsentsApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export interface ISendEICFConsentToAssistantParams {
    id: number;
    language: string;
}

export function useSendEICFConsentToAssistant() {
    const { t } = useTranslation();

    return useMutation<
        { assistantName: string; assistantEmail: string },
        AppMedError,
        ISendEICFConsentToAssistantParams
    >({
        mutationKey: [
            QueryKeys.eicfSignedPhysicianConsents,
            'sendToAssistant',
        ],
        mutationFn: async ({ id, language }) => {
            return await EICFConsentsApi.sendToAssistant(id, language);
        },
        onSuccess: ({ assistantName, assistantEmail }) => {
            notifications.show({
                title: t('eicf.notifications.sendToAssistantSuccess'),
                message: t('eicf.notifications.sendToAssistantSuccessMessage', {
                    assistantName,
                    assistantEmail,
                }),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('eicf.notifications.sendToAssistantError'),
                message:
                    error?.message ||
                    t('eicf.notifications.sendToAssistantErrorMessage'),
                color: 'red',
            });
        },
    });
}
